import { Component, OnInit,ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CampaignHeaderComponent } from '../campaign-header/campaign-header.component';
import { CampaignService } from 'src/app/_services/campaign.service';
import { targetData }  from 'src/app/model/campaign';
import { targetList } from '../sampleData';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SharedService } from '../shared-service.service';
import * as _ from 'underscore';
import { TransactionService } from 'src/app/_services/transaction.service';


@Component({
  selector: 'app-campaign-listing',
  templateUrl: './campaign-listing.component.html',
  styleUrls: ['./campaign-listing.component.scss']
})
export class CampaignListingComponent implements OnInit {

  /**list of candidates data in campaign */
  targetData: any = [];
  /**campaign data */
  campaignData: any = {};
  /**Mat table keys */
  displayedColumns: string[] = ['target_name', 'target_email' ,'status', 'steps', 'date'];

  /**current page */
  pageIndex: number = 1;
  /**size of page */
  pageSize: number = 10;
  /**total target results in campaign */
  totalResultCount: number = 0;
  /** will used to send object key in url params*/
  targetObject: Record<string, any> = {}

  /**campaign id of current campaign */
  currentCampaignId: number ;
  /**target_id used to send in slider */
  target_id:any;
  // target_email:string;

  /** Types of eamil which we are searching*/
  emailType: string;
  emailPref: number;

  /**Filters applied or not including search candidate input */
  emailFiltersApplied: boolean = false;
  searchApplied: boolean = false;
  isAnyFiltersApplied :boolean = false;
  
  /**Subject to send data in header, filters and slider */
  candidateIdSubject: Subject<any> = new Subject();
  campaignStatsSubject: Subject<any> = new Subject();
  stageDataSubject: Subject<any> = new Subject();
  filtersInfoSubjecct: Subject<any> = new Subject();

  currentCandidate: any;
  
  /**For starter page which loads only one time when campaign created */
  showAddCandidatePage: boolean = false;

  /**To calculate number of steps */ 
  numberOfStages: number;

  /**target listing data api */
  isTargetDataApiCalled = false;

  /**Is target data called after bulk reveal */
  isBulkRevealInProcess = false;

  userEmailId: string = '';
 
  isPipelineFilterSelected: boolean = false;

  isCompletedFilterSelected: boolean = false;
  
  isOpenedFilterSelected: boolean = false;

  isRepliedFilterSelected: boolean = false;

  statusFilter: any = 'All';
  

  constructor(private emailCampaignService : CampaignService, private route: ActivatedRoute, private router: Router, private _localstorageservice: LocalStorageService, private transactionservice : TransactionService) { 
    // this.showAddCandidatePage = this.router.url.split('/').includes('add-candidate');
  }

  ngOnInit() {
    this.currentCampaignId = +this.route.snapshot.paramMap.get('campaign_id');
    this.userEmailId = this._localstorageservice.getItem('usermailid');
    this.totalResultCount = 0;
    this.isTargetDataApiCalled = false;
    // this.getCampaignStats();
    // this.getTargetList();

    const filterObj = this._localstorageservice.getItem('email-campaign-filters') || {};
    let filterObject = {}
    filterObject['emailFound'] = filterObj?.emailFilter;

    if(filterObj?.statusFilter === 'unsubscribed'){
      if(filterObj['opened']) delete filterObj['opened'];
      filterObj['status[]'] = (Array.isArray(filterObj['status[]'])) ? filterObj['status[]'].push(9) : [9];
    }
    else{
      if(Array.isArray(filterObj['status[]'])){
        filterObj['status[]'] = filterObj['status[]'].filter(x=>(x != 9));
      }
      filterObj['opened'] = this.statusFilter
    };
    filterObject['stage[]'] = filterObj?.stepsFilter;
    this.emailFilters(filterObject);

    // this.sharedService.getBulkRevealStatus().subscribe((res: boolean)=>{
    //   if(res) this.isBulkRevealInProcess = res;
    // });

    this.fetchCurrentCredits();
  
  }

  fetchCurrentCredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this._localstorageservice.getItem('userdata')
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits
        this._localstorageservice.setItem('userdata', userData)
        this.transactionservice.createPaymentData();
      }
    })
  }

  /**Banner of Bulk Reveal in process */
  bulkRevealStatusForBanner() {
    this.emailCampaignService.bulkRevealStatus(this.currentCampaignId).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.isBulkRevealInProcess = (res.totalCount > 0) ? true : false
      }
    }, (err) => { this.isBulkRevealInProcess = false; }
    )
  }

  /**List of all candidates/targets available in campaign */
  getTargetList(){
    this.targetObject = {
      ...this.targetObject,
      page: this.pageIndex - 1 ,
      limit: this.pageSize
    }
    
    this.emailCampaignService.getCampaignTargets(this.currentCampaignId, this.targetObject).subscribe((response :any)=>{
      if(response && response.data){
        this.isTargetDataApiCalled = true;
        const tempData = response?.data;
        this.totalResultCount = response?.total;
        this.targetData = tempData.map(res=>{
          let data: any = {};
          data['target_name'] = res?.target?.target_name;
          data['campaign_target_id'] = res?.campaign_target_id;
          data['campaign_id'] = res?.campaign_id;
          data['target_id'] = res?.target.target_id;
          data['target_email'] = res?.target?.target_email;
          data['targetStatus'] = res?.status;
          try {
            data['candidatenumber'] = JSON.parse(res?.target?.target_meta || '{}')?.candidatenumber;
          } catch (err) {
            console.log('invalide target meta candidate number', err);
          }
          try {
            data['title'] = JSON.parse(res?.target?.target_meta || '{}')?.title;
          } catch (err) {
            console.log('invalide target meta title', err);
            data['title'] = '-';
          }
          data['created_on'] = res?.target?.created_on;
          data['target_email'] = res?.target?.target_email;
          data['status'] = res?.stats?.opened_on;
          data['steps'] = res?.stats?.step;
          // this.target_email = res?.target?.target_email;
          return data;
        }) 

        this.showAddCandidatePage  = (this.targetData.length === 0) ? true : false;
        this.emailFiltersApplied = (this.targetObject['opened'] || this.targetObject['emailFound'] || this.targetObject['stage[]'] || this.targetObject['status[]']) ? true : false;
        this.searchApplied = (this.targetObject['name']) ? true : false;
        this.isAnyFiltersApplied = this.emailFiltersApplied || this.searchApplied;

        this.filtersInfoSubjecct.next({filters:this.isAnyFiltersApplied, addCandidate:this.showAddCandidatePage});
      }
    })

    this.getCampaignStats();
    this.bulkRevealStatusForBanner();

  }

  /**Delete Target */
  deleteTarget(targetId){
    const data = {
      status:6,
      // target_id:targetId
    }
    this.emailCampaignService.updateTarget(this.currentCampaignId, targetId, data).subscribe((res:any)=>{
      if(res.status=='success'){
        this.getTargetList();
      }
    })
  }

  /**Stats of campaign */
  getCampaignStats(){
    this.emailCampaignService.getCampaignStats(this.currentCampaignId, _.pick(this.targetObject, ['status[]', 'opened', 'replied'])).subscribe((res: any)=>{
      if(res && res['data'] && res['data'].length){
        const tempData = res['data'][0];
        if(tempData['created_by']!==this._localstorageservice.getItem('userdata')?.userid){
          this.router.navigate(['email-campaign/campaign-listing']);
          return;
        }
        this.campaignData['stats'] = tempData?.stats;
        this.campaignData['campaignName'] =  tempData?.campaign_name;
        this.campaignData['user'] = tempData?.user
        this.campaignData['status'] = tempData?.status
        this.campaignData['emailPref'] = tempData?.email_pref;
        this.emailPref = tempData?.email_pref;
        if(tempData?.email_pref === 1){
          this.emailType = 'Personal Only'
        }
        else if(tempData?.email_pref === 2){
          this.emailType = 'Professional Only'
        }
        else if(tempData?.email_pref === 3){
          this.emailType = 'Prefered Personal'
        }
        else if(tempData?.email_pref === 4){
          this.emailType = 'Prefered Professional'
        }

        if(this.campaignData.stats.pipeline == 0) this.isPipelineFilterSelected = false;
        if(this.campaignData.stats.completed == 0) this.isCompletedFilterSelected = false;
        if(this.campaignData.stats.opened == 0 || this.campaignData.stats.opened == null) this.isOpenedFilterSelected = false;
        if(this.campaignData.stats.replied == 0 || this.campaignData.stats.replied == null) this.isRepliedFilterSelected = false;

        this.campaignStatsSubject.next(this.campaignData);
      }
    })
  }

  getFormattedDate(date: string){
    return moment(date).format('DD MMM YYYY');
  }

  filterSlider_open(){ 
    document.getElementById("mySidebar_email_filter").style.display = "block";
    document.getElementById("myOverlay_email_filter").style.display = "block";
    this.getStageData();
  }

  // candidateSlider_open(candidatenumber: string, camp_target_id:any, target_id:any, tabtoShow:string){
  candidateSlider_open(element, tabtoShow: string, add_email_manually: boolean) {

    /**This subject is used in slider to access target details */
    this.candidateIdSubject.next(
      [
        { type: 'ID', data: element?.candidatenumber },
        { type: 'CAMPAIGN_NAME', data: this.campaignData['campaignName'] },
        { type: 'CAMPAIGN_TARGET_ID', data: element?.campaign_target_id },
        { type: 'TARGET_ID', data: element?.target_id },
        { type: 'CAMPAIGN_ID', data: this.currentCampaignId },
        { type: 'TARGET_EMAIL', data: element?.target_email },
        { type: 'TAB_TO_SHOW', data: tabtoShow },
        { type: 'Email_Pref', data: this.emailPref },
        { type: 'add_email_manually', data: add_email_manually},
        { type: 'target_status', data: element?.targetStatus }
      ]
    );
    document.getElementById("candidate_slider").style.display = "block";
    document.getElementById("candidate_Overlay2").style.display = "block";
  }

  /**
   * Used for pagination
   * @param index Page clicked on pagination
   */
  setPage(index: number) {
    this.pageIndex = index;
    this.getTargetList();
  }

  /**Filters */
  emailFilters(event) {
    this.targetObject = {};
    Object.keys(event).forEach(res => {
      if (event[res] && event[res] != 'All')
        this.targetObject[res] = event[res]
      else if (event[res] === 'All')
        delete this.targetObject[res]


      if(res === 'opened' && (event[res] == 'true' || event[res] == true)) {
        this.targetObject[res] = event[res]
        this.isOpenedFilterSelected = true;
        this.statusFilter = 'true';
        this.targetObject['status[]'] && Array.isArray(this.targetObject['status[]']) && this.targetObject['status[]'].includes(2) && delete this.targetObject['status[]'];
      }
      else if (res === 'opened' && (event[res] == 'All')) {
        this.isOpenedFilterSelected = false;
        this.statusFilter = 'All';
        delete this.targetObject[res]
      } else if (res === 'opened' && (event[res] == 'false' || event[res] == false)) {
        this.isOpenedFilterSelected = false;
        this.statusFilter = 'false';
      }
    }
    )
    if(this.targetObject['stage[]'] && this.targetObject['stage[]'].length==0){
      delete this.targetObject['stage[]']
    }
    if(this.targetObject['status[]'] && this.targetObject['status[]'].length === 0){
      delete this.targetObject['status[]'];
    }
    if(!Object.keys(event).length){
      delete this.targetObject['stage[]']
    }
    if((this.targetObject['opened'] || this.targetObject['emailFound'] || this.targetObject['stage[]'] || this.targetObject['status[]'])){
      this.pageIndex = 1;
    }
    // this._localstorageservice.setItem('email-campaign-filters', { emailFilter: this.targetObject['emailFound'], statusFilter: this.targetObject['opened'], stepsFilter: this.targetObject['stage[]'] });
    this.getTargetList();
  }

  /**Search Candidate */
  typeaheadSearch(event){
    const input = event.target.value;
    this.pageIndex = 1;
    if(input){
      this.targetObject['name'] = input;
    }
    else{
      delete this.targetObject['name'];
    }
    this.getTargetList();
  }

  targetStatus(key){
    if(key){
      return "Opened";
    }
    else{
      "Not Opened"
    }
  }

  roundOff(num){
    if(!num) return 0;
    if(num === 0) return 0;
    return num.toFixed(2);
  }

  eventHandler(event){
    this.targetData.forEach(res=>{
      if(res.campaign_target_id === event.camp_target_id){
        if(event?.target_email){
          res['target_email'] = event.target_email
        }
        else{
          res['previewAvailable'] = event.previewAvailable
        }
        if(event?.status){
          res['targetStatus'] = event?.status;
        }
      }
    })

  }

  getStageData(){
    this.emailCampaignService.getStages(this.currentCampaignId).subscribe((response:any)=>{
      if(response && response.data && response.data.length){
        this.numberOfStages = response.data.length;
        this.stageDataSubject.next(this.numberOfStages);
      }
    })
  }
  removeBulkProcessDiv(){
    const ele = document.getElementById("bulk-process");
    ele.style.display = 'none';
  }

  ngOnDestroy(){
    this._localstorageservice.setItem('email-campaign-filters',{emailFilter:'All',statusFilter:'All',stepsFilter:[]});
  }

  /**
   * Stats Filter Clickable
   * @param type 
   */
  onStatsFilterSelected(type: string) {
    switch(type) {
      case 'pipeline':{ 
                      this.isPipelineFilterSelected = !this.isPipelineFilterSelected; 
                      this.isPipelineFilterSelected && this.isCompletedFilterSelected ? this.targetObject['status[]'] = [2, 3] : this.isPipelineFilterSelected ? this.targetObject['status[]'] = [2] : this.isCompletedFilterSelected ? this.targetObject['status[]'] = [3] : delete this.targetObject['status[]'];
                      break;
                    }
      case 'completed': {
                        this.isCompletedFilterSelected = !this.isCompletedFilterSelected; 
                        this.isPipelineFilterSelected && this.isCompletedFilterSelected ? this.targetObject['status[]'] = [2, 3] : this.isPipelineFilterSelected ? this.targetObject['status[]'] = [2] : this.isCompletedFilterSelected ? this.targetObject['status[]'] = [3] : delete this.targetObject['status[]'];
                        break;
                      }
      case 'opened': {
                        this.isOpenedFilterSelected = !this.isOpenedFilterSelected;
                        this.isOpenedFilterSelected ? this.targetObject['opened'] = this.isOpenedFilterSelected : delete this.targetObject['opened'];
                        break;
                      }
      case 'replied': {
                        this.isRepliedFilterSelected = !this.isRepliedFilterSelected; 
                        this.isRepliedFilterSelected ? this.targetObject['replied'] = this.isRepliedFilterSelected : delete this.targetObject['replied'];
                        break;
                      }
    }
    this.pageIndex = 1;
    this.emailFilters({ opened: this.isOpenedFilterSelected});
  } 
}

